import colors from '../../constants/colors'
import dayjs from 'dayjs'

const typographyStyle = {
  color: colors.WHITE,
  p: '1rem',
  lineHeight: '4rem',
  span: {
    height: '5rem',
  },
}

const selectedDateStyle = {
  backgroundColor: '#216ba5 !important',
  borderRadius: '50%',
}

const currentTime = dayjs()

export const presets: { [key: string]: any } = {
  1: {
    text: 'All Time',
    start: dayjs().startOf('year'),
    end: currentTime,
  },
  2: {
    text: 'Last week',
    start: dayjs().subtract(1, 'week'),
    end: currentTime,
  },
  3: {
    text: 'Last 3 weeks',
    start: dayjs().subtract(3, 'week'),
    end: currentTime,
  },
  4: {
    text: 'Last 12 weeks',
    start: dayjs().subtract(12, 'week'),
    end: currentTime,
  },
  5: {
    text: 'Last Month',
    start: dayjs().subtract(1, 'month'),
    end: currentTime,
  },
  6: {
    text: 'Last 3 Months',
    start: dayjs().subtract(3, 'month'),
    end: currentTime,
  },
  7: {
    text: 'Last 6 Months',
    start: dayjs().subtract(6, 'month'),
    end: currentTime,
  },
  8: {
    text: 'Last 12 Months',
    start: dayjs().subtract(12, 'month'),
    end: currentTime,
  },
  9: {
    text: 'Last Year',
    start: dayjs()
      .year(dayjs().year() - 1)
      .startOf('year'),
    end: dayjs()
      .year(dayjs().year() - 1)
      .endOf('year'),
  },
  10: {
    text: 'This Year to Date',
    start: dayjs().startOf('year'),
    end: currentTime,
  },
}

export default { typographyStyle, selectedDateStyle }
